import React, { useState } from 'react';
import { Mail, ChevronDown } from 'lucide-react';

const LaserCoursePage = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [coursesOpen, setCoursesOpen] = useState(false);

  // Mock Link component for demo
  const Link = ({ to, children, className, onClick }) => (
    <a href={to} className={className} onClick={onClick}>
      {children}
    </a>
  );

  return (
    <div className="bg-[#f7f6f3] text-gray-800 font-sans">
      {/* Header Bar */}
      <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
        <div className="flex flex-col md:flex-row items-center gap-2">
          <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">
            📧 admin@kentacademy.co.uk
          </a>
        </div>
        <a
          href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white hover:underline flex items-center gap-1"
        >
          <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
          facebook.com/KentAcademy
        </a>
      </div>

      {/* Navigation */}
      <nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
        <Link to="/" className="cursor-pointer">
  <img
    src="/assets/KaLogo.png"
    alt="Kent Academy"
    className="h-40 w-auto object-contain"
  />
</Link>

        </div>
        
       
{/* Desktop Nav */}
<div className="bg-[#f7f6f3] border-t border-gray-200 hidden md:flex">
  <div className="max-w-4xl mx-auto px-4 flex justify-between items-center text-sm font-medium py-3 relative w-full">
    <Link to="/" className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
    <Link to="/about" className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
    
    <div
      className="relative cursor-pointer group"
      onMouseEnter={() => setCoursesOpen(true)}
      onMouseLeave={() => setCoursesOpen(false)}
    >
      <div className="flex items-center gap-1 text-gray-800 hover:text-black transition-colors duration-200 cursor-pointer">
        <span>ALL COURSES</span>
        <ChevronDown 
          size={16} 
          className={`transition-transform duration-200 ${coursesOpen ? 'rotate-180' : ''}`}
        />
      </div>
      
      {/* Dropdown */}
      <div className={`absolute top-full left-1/2 transform -translate-x-1/2 mt-1 transition-all duration-200 z-50 ${
        coursesOpen 
          ? 'opacity-100 visible translate-y-0' 
          : 'opacity-0 invisible -translate-y-2'
      }`}>
        <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-white border-l border-t border-gray-200 rotate-45"></div>
        
        <div className="bg-white border border-gray-200 rounded-md shadow-lg w-64 overflow-hidden">
          <div className="py-1">
            <a 
              href="/courses/vietnamese-nails" 
              className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
            >
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-pink-600 rounded-full"></div>
                <div>
                  <h4 className="font-medium text-gray-900 text-sm">Level 3 in Nail Technology</h4>
                  <p className="text-xs text-gray-600">Bilingual training for UK professionals</p>
                </div>
              </div>
            </a>

            <a 
              href="/courses/laser-and-light" 
              className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
            >
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                <div>
                  <h4 className="font-medium text-gray-900 text-sm">Level 4 in Laser and Light</h4>
                  <p className="text-xs text-gray-600">Professional laser training</p>
                </div>
              </div>
            </a>
            
            <a 
              href="/courses/tattoo-removal" 
              className="block px-4 py-2 hover:bg-gray-50 transition-colors duration-150"
            >
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                <div>
                  <h4 className="font-medium text-gray-900 text-sm">Level 5 in Tattoo Removal</h4>
                  <p className="text-xs text-gray-600">CPD Available</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <Link to="/contact" className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
  </div>
</div>

        {/* Mobile Dropdown Toggle */}
        <div className="md:hidden flex justify-center pb-3">
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="text-sm border px-4 py-2 rounded text-gray-800 border-gray-600 hover:bg-gray-100 transition-colors duration-200"
          >
            {mobileOpen ? 'Close Menu' : 'Menu'}
          </button>
        </div>

        {/* Mobile Dropdown Nav */}
        {mobileOpen && (
          <div className="md:hidden bg-[#f7f6f3] border-t border-gray-200 px-6 py-4 flex flex-col items-center gap-3 text-sm font-medium">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">HOME</Link>
            <Link to="/about" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">ABOUT US</Link>
            <div className="text-gray-800 font-medium">COURSES:</div>
            <Link to="/courses/vietnamese-nails" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 3 in Nail Technology</Link>
            <Link to="/courses/laser-and-light" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 4 in Laser and Light</Link>
            <Link to="/courses/tattoo-removal" onClick={() => setMobileOpen(false)} className="text-gray-700 hover:text-black transition-colors duration-200 pl-4">Level 5 in Tattoo Removal</Link>
            <Link to="/contact" onClick={() => setMobileOpen(false)} className="text-gray-800 hover:text-black transition-colors duration-200">CONTACT</Link>
            <a
              href="mailto:admin@kentacademy.co.uk"
              className="inline-block border border-gray-800 text-gray-800 px-3 py-1 rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
            >
              Contact Us
            </a>
          </div>
        )}
      </nav>

      {/* Header */}
      <section className="relative pt-44 pb-16 px-6 w-full">
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-light mb-6">
            Level 4 in <span className="font-semibold">Laser and Light</span>
          </h1>
          <p className="text-2xl font-semibold text-blue-600 mb-4">£1,495.00</p>
          <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto">
            Master professional laser and IPL technology with our comprehensive accredited training program.
          </p>
        </div>
      </section>

      {/* Main Course Info Section */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-gray-700 leading-relaxed mb-6">
                Step into the world of professional aesthetics with our Level 4 Laser Hair Removal Course, designed for those who want to master the most in-demand treatment in the beauty industry. Whether you're an experienced therapist or looking to upskill, our comprehensive training is tailored to provide real, practical knowledge that delivers results.
              </p>
              
              <h3 className="text-xl font-semibold mb-4">Why Choose Us?</h3>
              <div className="space-y-3 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Taught by Industry Professionals</p>
                    <p className="text-gray-700 text-sm">Our training is led by experts with over 30 years of hands-on experience in aesthetics and laser technology.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Accredited Level 4 Curriculum</p>
                    <p className="text-gray-700 text-sm">Aligned with national standards, our Level 4 qualification ensures you are fully certified and compliant.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Learn on Cutting-Edge Technology</p>
                    <p className="text-gray-700 text-sm">We design and manufacture our own beauty machines, using the latest in laser and IPL technology.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <div>
                    <p className="font-semibold text-gray-900">Flexible Training Options</p>
                    <p className="text-gray-700 text-sm">Learn one-on-one or in a group, at our fully equipped academy or in your own salon.</p>
                  </div>
                </div>
              </div>
              
              <a href="mailto:admin@kentacademy.co.uk" className="inline-block bg-gray-800 text-white px-6 py-3 rounded hover:bg-black transition-colors duration-200">
                Enquire About This Course
              </a>
            </div>
            <div className="relative">
              <img 
                src="/assets/Laser2.JPG" 
                alt="Laser and Light Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* What You'll Learn Section */}
      <section className="py-16 bg-[#f7f6f3]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="relative order-2 md:order-1">
              <img 
                src="/assets/Laser1.jpg" 
                alt="Hands-on Laser Training" 
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="order-1 md:order-2">
              <h3 className="text-3xl md:text-4xl font-light mb-6">
                What You'll <span className="font-semibold">Learn</span>
              </h3>
              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Laser and IPL theory</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Client consultation & contraindications</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Hair growth cycles & treatment planning</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Machine settings & skin typing</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Safety protocols & legislation</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-blue-600 rounded-full mt-2"></div>
                  <p className="text-gray-700">Hands-on practice with live models</p>
                </div>
              </div>
              
              <h4 className="text-xl font-semibold mb-4">Who Can Enroll?</h4>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700">• Qualified beauty therapists (Level 3 or equivalent)</p>
                <p className="text-gray-700">• Medical professionals entering aesthetics</p>
                <p className="text-gray-700">• Salon owners looking to expand their service offerings</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 bg-gray-800 text-white text-center">
        <div className="max-w-4xl mx-auto px-6">
          <h3 className="text-3xl md:text-4xl font-light mb-6">
            Ready to Start Your <span className="font-semibold">Laser Training Journey?</span>
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
            Join hundreds of successful graduates who have transformed their careers with our professional laser training program.
          </p>
          <a
            href="mailto:admin@kentacademy.co.uk"
            className="inline-block bg-white text-gray-800 px-8 py-3 rounded hover:bg-gray-100 transition-colors duration-200 font-medium"
          >
            Contact Us Today
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8 text-sm">
          <div>
            <img src="/assets/KaLogo.png" alt="Kent Academy" className="w-14 mb-3" />
            <p className="text-gray-300">
              Kent Academy delivers advanced beauty training with professional-grade equipment and expert guidance.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Courses</h4>
            <ul className="space-y-1 text-gray-400">
              <li>Level 4 in Laser and Light</li>
              <li>Level 5 in Tattoo Removal</li>
              <li>Vietnamese Nail Courses</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2">Contact</h4>
            <ul className="space-y-1 text-gray-400">
              <li>
                <a href="mailto:admin@kentacademy.co.uk" className="hover:text-gray-300 transition-colors duration-200">
                  admin@kentacademy.co.uk
                </a>
              </li>
              <li>General: 07548321022</li>
              <li>Vietnamese Courses: 07548321022</li>
              <li>Unit 10, Creative Quarter, Javelin Way, Ashford TN24 8FN</li>
              <li>
                <a
                  href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-white hover:underline"
                >
                  <img src="/assets/facebook-icon.png" alt="Facebook" className="w-6 h-6" />
                  facebook.com/KentAcademy
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 text-center text-xs text-gray-400">© 2025 Kent Academy. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default LaserCoursePage;